<template>
    <div>
        <b-row>
            <b-col cols="12" v-for="doc in mergedDocuments" :key="doc.type">
                <b-alert
                    show
                    :variant="getDocumentVariant(doc.status, doc.type)"
                >
                    <b-row v-if="!editSwitches[doc.type]">
                        <b-col cols="12" md="4">
                            <b-button
                                variant="outline-primary"
                                @click="downloadFile(doc.type)"
                                :disabled="doc.status !== 'uploaded'"
                            >
                                <i
                                    class="ri-download-2-line font-size-16 mr-2"
                                ></i>
                                {{ doc.label }}
                            </b-button>
                        </b-col>
                        <b-col
                            cols="12"
                            md="6"
                            class="d-flex justify-content-center"
                        >
                            <template v-if="doc.status === 'uploaded'">
                                <b-button
                                    v-if="!documentApprovals[doc.type]"
                                    variant="success"
                                    class="mr-2"
                                    @click="doApprove(doc.type, 'approved')"
                                    >{{ $t("approve") }}</b-button
                                >
                                <b-button
                                    v-if="!documentApprovals[doc.type]"
                                    variant="danger"
                                    class="mr-2"
                                    @click="doApprove(doc.type, 'declined')"
                                    >{{ $t("reject") }}</b-button
                                >
                                <b-button
                                    v-if="documentApprovals[doc.type]"
                                    :variant="documentApprovals[doc.type]"
                                    class="mr-2"
                                >
                                    {{
                                        documentApprovals[doc.type] ===
                                        "success"
                                            ? $t("approved")
                                            : $t("rejected")
                                    }}
                                </b-button>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col cols="8">
                            <ValidationObserver
                                :ref="'formValidate_' + doc.type"
                            >
                                <ValidationProvider
                                    :name="doc.type"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <b-input-group class="mb-0 mt-1">
                                        <b-form-file
                                            v-model="fileInputs[doc.type]"
                                            :placeholder="doc.label"
                                            :state="errors[0] ? false : null"
                                        />
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        v-if="errors[0]"
                                        v-html="errors[0]"
                                    />
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="4" class="d-flex justify-content-start">
                            <b-button
                                variant="primary"
                                class="mt-1 mr-2"
                                @click="saveFile(doc.type)"
                                >{{ $t("save") }}</b-button
                            >
                            <b-button
                                variant="secondary"
                                class="mt-1 mr-2"
                                @click="toggleEdit(doc.type)"
                                >{{ $t("cancel") }}</b-button
                            >
                        </b-col>
                    </b-row>
                </b-alert>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import BisepService from "@/services/BisepService";

export default {
    name: "DocumentsTab",
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        formId: {
            type: Number,
            required: true,
        },
        formData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editSwitches: {},
            fileInputs: {},
            documentApprovals: {},
        };
    },

    computed: {
        documentParameters() {
            const param = this.$store.getters.getParameter(
                "bisep_applications.documents"
            );
            return param ? param.items : [];
        },
        mergedDocuments() {
            return this.documentParameters?.map((item) => {
                const type = item.code;
                return {
                    type: type,
                    label: this.getLocaleText(item, "name"),
                    status: this.formData.documents
                        ? this.formData.documents[type]
                        : "not_uploaded",
                };
            });
        },
    },
    async mounted() {
        await this.$store.dispatch("fetchParameter", {
            parameterCode: "bisep_applications.documents",
        });
    },
    methods: {
        getDocumentVariant(status, type) {
            if (this.documentApprovals[type])
                return this.documentApprovals[type];
            return status === "uploaded" ? "info" : "secondary";
        },
        toggleEdit(type) {
            this.$set(this.editSwitches, type, !this.editSwitches[type]);
            if (!this.editSwitches[type]) {
                this.$set(this.fileInputs, type, null);
            }
        },
        doApprove(type, approve) {
            const data = {
                bisep_application_id: this.formId,
                type: type,
                status: approve,
            };
            BisepService.approveDocument(data)
                .then((response) => {
                    this.$toast.success(
                        this.$t("api." + response.data.message)
                    );
                    this.$set(
                        this.documentApprovals,
                        type,
                        approve ? "success" : "danger"
                    );
                })
                .catch((e) => {
                    this.showErrors(e);
                });
        },
        downloadFile(type) {
            const data = {
                bisep_application_id: this.formId,
                type: type,
            };
            BisepService.adminDownloadFile(data)
                .then((response) => {
                    this._downloadFile(
                        response,
                        type + "." + response.headers.file_extension
                    );
                })
                .catch((e) => {
                    this.showErrors(e);
                });
        },
        async saveFile(type) {
            this.$toast.info(
                "Save functionality to be implemented if required."
            );
            this.toggleEdit(type);
        },
    },
};
</script>
